import { makeRequest } from "./api";

export const FetchProperties = async (billingType, page, limit, keyword) => {
  return makeRequest(
    `/api/admin/managed-by-ghorfatech/properties?billingType=${billingType}&page=${page}&limit=${limit}&keyword=${keyword}`,
  );
};
